import { Component } from 'react';
import ErrorModal from '../templates/ErrorModal';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught:', error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            // Render the provided fallback, or the shared ErrorModal — but NEVER
            // fall back to the children that just threw. Doing so makes React
            // re-render them, they throw again, getDerivedStateFromError fires
            // again, and the whole tree remounts in a tight loop, re-firing every
            // effect/API call until the server is overwhelmed.
            if (this.props.fallback) return this.props.fallback;

            // forceShow bypasses ErrorModal's beta-only gate so every user sees a
            // consistent error on a render crash. The synthesized message mirrors
            // the API-error shape ErrorModal expects; the error name lands in the
            // generic "unexpected error" case.
            return (
                <ErrorModal
                    forceShow
                    onClose={this.handleReload}
                    message={{
                        status: this.state.error?.name || 'Error',
                        url: window.location.href,
                    }}
                />
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
